import React, {
  CSSProperties,
  MouseEventHandler,
  useCallback,
  useMemo,
  MouseEvent,
} from 'react'
import formatTime from 'lib/format-time'
import classNames from 'classnames'
import noopWrapper, { Wrapper } from 'lib/noop-wrapper'
import communityLink from 'Components/new/links/community-link'
import useToggleCollect from 'Components/hooks/use-toggle-collect'
import useToggleDigg, {
  IToggleDiggParams,
} from 'Components/hooks/use-toggle-digg'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'

export const replyIcon = require('static/reply.svg')
export const likeNormalIcon = require('static/like-normal.svg')
export const likeActiveIcon = require('static/like-active.svg')

function makeCollectNormalIcon({ theme }: { theme: 'light' | 'black' }) {
  const fill = theme === 'black' ? '%23c9cbd6' : '%231F2129'
  return (
    `${
      'data:image/svg+xml;utf8,' +
      '<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
      '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
      '        <g transform="translate(-1690.000000, -3920.000000)" fill="'
    }${fill}">` +
    `            <g transform="translate(1690.000000, 3920.000000)">` +
    `                <path d="M9.23743323,1.64488128 C9.5639883,1.07692854 10.3664251,1.05734396 10.7257996,1.58612755 L10.7625668,1.64488128 L13.2404167,5.95458333 L18.0988526,6.98341626 C18.7403734,7.11923087 19.0064109,7.87811951 18.611819,8.38316819 L18.5701471,8.43279444 L15.2429167,12.125 L15.5381562,14.8829483 L13.788881,15.0701098 L13.4520284,11.9217696 C13.4280935,11.6980665 13.4908377,11.4747072 13.6256128,11.2968902 L13.6731855,11.2393666 L16.2416667,8.38833333 L12.4918407,7.59462326 C12.2716387,7.5480049 12.0786652,7.41901082 11.9513965,7.23562433 L11.9114599,7.17251935 L10,3.84833333 L8.08854015,7.17251935 C7.97634752,7.36764757 7.79417498,7.51149263 7.58049875,7.57607124 L7.50815931,7.59462326 L3.75791667,8.38833333 L6.32681447,11.2393666 C6.47724824,11.4063194 6.55744212,11.6237332 6.55277486,11.8465621 L6.54805605,11.9209772 L6.14291667,15.7379167 L9.64085991,14.1735554 C9.84383443,14.0827725 10.0726325,14.0726219 10.2813898,14.1431178 L10.3586448,14.1733341 L16.0100281,16.696805 L15.2927385,18.303195 L10,15.9395833 L5.46637102,17.9678554 C4.86663862,18.2360933 4.20380016,17.7768729 4.22799731,17.1347837 L4.2325089,17.0720934 L4.75708333,12.1254167 L1.42985289,8.43279444 C0.990902152,7.94564278 1.22208576,7.17542068 1.83825749,6.99904216 L1.90114739,6.98341626 L6.75916667,5.95458333 L9.23743323,1.64488128 Z"></path>` +
    `                <rect opacity="0" x="0" y="0" width="20" height="20"></rect>` +
    `            </g>` +
    `        </g>` +
    `    </g>` +
    `</svg>`
  )
}

function makeCollectActiveIcon({ theme }: { theme: 'light' | 'black' }) {
  const border =
    theme === 'light'
      ? '<g fill="%231F2129">' +
        '<path d="M9.23743323,1.64488128 C9.5639883,1.07692854 10.3664251,1.05734396 10.7257996,1.58612755 L10.7625668,1.64488128 L13.2404167,5.95458333 L18.0988526,6.98341626 C18.7403734,7.11923087 19.0064109,7.87811951 18.611819,8.38316819 L18.5701471,8.43279444 L15.2429167,12.125 L15.5381562,14.8829483 L13.788881,15.0701098 L13.4520284,11.9217696 C13.4280935,11.6980665 13.4908377,11.4747072 13.6256128,11.2968902 L13.6731855,11.2393666 L16.2416667,8.38833333 L12.4918407,7.59462326 C12.2716387,7.5480049 12.0786652,7.41901082 11.9513965,7.23562433 L11.9114599,7.17251935 L10,3.84833333 L8.08854015,7.17251935 C7.97634752,7.36764757 7.79417498,7.51149263 7.58049875,7.57607124 L7.50815931,7.59462326 L3.75791667,8.38833333 L6.32681447,11.2393666 C6.47724824,11.4063194 6.55744212,11.6237332 6.55277486,11.8465621 L6.54805605,11.9209772 L6.14291667,15.7379167 L9.64085991,14.1735554 C9.84383443,14.0827725 10.0726325,14.0726219 10.2813898,14.1431178 L10.3586448,14.1733341 L16.0100281,16.696805 L15.2927385,18.303195 L10,15.9395833 L5.46637102,17.9678554 C4.86663862,18.2360933 4.20380016,17.7768729 4.22799731,17.1347837 L4.2325089,17.0720934 L4.75708333,12.1254167 L1.42985289,8.43279444 C0.990902152,7.94564278 1.22208576,7.17542068 1.83825749,6.99904216 L1.90114739,6.98341626 L6.75916667,5.95458333 L9.23743323,1.64488128 Z"></path>' +
        '<rect opacity="0" x="0" y="0" width="20" height="20"></rect>' +
        '</g>'
      : ''
  return (
    `${
      'data:image/svg+xml;utf8,' +
      '<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
      '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
      '        <g transform="translate(-1690.000000, -3943.000000)">' +
      '            <g transform="translate(1690.000000, 3943.000000)">' +
      '                <g fill="%23FFCC32" transform="translate(0.833333, 0.833333)">' +
      '                    <path d="M8.40409989,0.811547947 C8.73065496,0.243595205 9.53309178,0.224010627 9.89246628,0.752794215 L9.92923344,0.811547947 L12.4070833,5.12125 L17.2655193,6.15008293 C17.885656,6.28137038 18.1549245,6.9948859 17.8157533,7.49851633 L17.7784856,7.54983485 L17.7368138,7.59946111 L14.4091667,11.2920833 L14.9341578,16.2387601 C15.0012248,16.8710057 14.4022041,17.3484426 13.8169595,17.1775016 L13.7585061,17.1582279 L13.7002957,17.1345221 L9.16666667,15.10625 L4.63303768,17.1345221 C4.03330529,17.40276 3.37046683,16.9435395 3.39466398,16.3014503 L3.39917557,16.2387601 L3.92375,11.2920833 L0.59651956,7.59946111 C0.157568819,7.11230944 0.388752431,6.34208735 1.00492415,6.16570883 L1.06781406,6.15008293 L5.92583333,5.12125 L8.40409989,0.811547947 Z"></path>' +
      '                </g>' +
      '                <rect fill="%231F2129" opacity="0" x="0" y="0" width="20" height="20"></rect>'
    }${border}            </g>` +
    `        </g>` +
    `    </g>` +
    `</svg>`
  )
}

export const collectNormalIcon = makeCollectNormalIcon({ theme: 'light' })
export const collectActiveIcon = makeCollectActiveIcon({ theme: 'light' })

export const collectNormalIconBlack = makeCollectNormalIcon({ theme: 'black' })
export const collectActiveIconBlack = makeCollectActiveIcon({ theme: 'black' })

export const diggNormalIcon =
  'data:image/svg+xml;utf8,' +
  '<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
  '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
  '        <g transform="translate(-1659.000000, -3920.000000)" fill="%231F2129">' +
  '            <g transform="translate(1659.000000, 3920.000000)">' +
  '                <path d="M11.25,1.66666667 C11.8997468,1.66666667 12.4337072,2.16240674 12.4942779,2.79628332 L12.5,2.91666667 L12.4991667,6.66666667 L17.311444,6.66666667 C17.9611907,6.66666667 18.4951512,7.16240674 18.5557218,7.79628332 L18.561444,7.91666667 C18.561444,7.9903779 18.5549241,8.06387193 18.5419981,8.13629501 L18.5178187,8.2440197 L16.556,15.4685832 C16.1687381,16.6286042 15.1192501,17.4280666 13.9151116,17.4953922 L13.75,17.5 L9.58333333,17.5 L9.58333333,15.8333333 L13.75,15.8333333 C14.2636724,15.8333333 14.7258336,15.524721 14.9210803,15.0891511 L14.9613011,14.986464 L16.7666667,8.33333333 L11.6666667,8.33333333 C11.2393035,8.33333333 10.8870774,8.01163317 10.8389398,7.59718427 L10.8333333,7.5 L10.8325,3.33333333 L9.64530861,3.33333333 L6.96981575,7.91989252 C6.83706736,8.14746119 6.60575687,8.29713262 6.34782979,8.32758345 L6.25,8.33333333 L3.75,8.33333333 L3.74916667,15.8333333 L6.24916667,15.8333333 L6.25,11.25 L7.91666667,11.25 L7.91666667,16.6666667 C7.91666667,17.0940299 7.59496651,17.446256 7.1805176,17.4943936 L7.08333333,17.5 L2.91666667,17.5 C2.48930347,17.5 2.13707737,17.1782998 2.08893978,16.7638509 L2.08333333,16.6666667 L2.08333333,8.33333333 C2.08333333,7.4546985 2.76323149,6.7348624 3.62561471,6.67123811 L3.75,6.66666667 L5.77083333,6.66666667 L8.20567711,2.49354829 C8.48138531,2.02090567 8.96967269,1.71627218 9.50939872,1.6722022 L9.64530861,1.66666667 L11.25,1.66666667 Z"></path>' +
  '                <rect opacity="0" x="0" y="0" width="20" height="20"></rect>' +
  '            </g>' +
  '        </g>' +
  '    </g>' +
  '</svg>'

export const diggActiveIcon =
  'data:image/svg+xml;utf8,' +
  '<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
  '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
  '        <g transform="translate(-1659.000000, -3943.000000)">' +
  '            <g transform="translate(1659.000000, 3943.000000)">' +
  '                <g fill="%23FFCC32">' +
  '                    <path d="M11.25,1.66666667 C11.8972087,1.66666667 12.4295339,2.15854133 12.4935464,2.78886143 L12.5,2.91666667 L12.4991667,6.66666667 L17.311444,6.66666667 C17.9178743,6.66666667 18.4234418,7.09851135 18.5374018,7.67145578 L18.5557218,7.79628332 L18.561444,7.91666667 C18.561444,7.9903779 18.5549241,8.06387193 18.5419981,8.13629501 L18.5178187,8.2440197 L16.556,15.4685832 C16.1713786,16.620695 15.1335305,17.417148 13.93972,17.4939131 L13.75,17.5 L7.91666667,17.5 L7.91666667,11.25 L6.25,11.25 L6.25,17.5 L2.91666667,17.5 C2.49183224,17.5 2.14124835,17.1820957 2.08982618,16.7711982 L2.08333333,16.6666667 L2.08333333,8.33333333 C2.08333333,7.46130478 2.7530459,6.74569598 3.60619362,6.67278433 L3.75,6.66666667 L5.77083333,6.66666667 L8.20567711,2.49354829 C8.45381449,2.06816993 8.87414101,1.77887897 9.34918521,1.69314754 L9.50939872,1.6722022 L9.64530861,1.66666667 L11.25,1.66666667 Z"></path>' +
  '                </g>' +
  '                <rect fill="%231F2129" opacity="0" x="0" y="0" width="20" height="20"></rect>' +
  '                <g fill="%231F2129">' +
  '                    <path d="M11.25,1.66666667 C11.8997468,1.66666667 12.4337072,2.16240674 12.4942779,2.79628332 L12.5,2.91666667 L12.4991667,6.66666667 L17.311444,6.66666667 C17.9611907,6.66666667 18.4951512,7.16240674 18.5557218,7.79628332 L18.561444,7.91666667 C18.561444,7.9903779 18.5549241,8.06387193 18.5419981,8.13629501 L18.5178187,8.2440197 L16.556,15.4685832 C16.1687381,16.6286042 15.1192501,17.4280666 13.9151116,17.4953922 L13.75,17.5 L9.58333333,17.5 L9.58333333,15.8333333 L13.75,15.8333333 C14.2636724,15.8333333 14.7258336,15.524721 14.9210803,15.0891511 L14.9613011,14.986464 L16.7666667,8.33333333 L11.6666667,8.33333333 C11.2393035,8.33333333 10.8870774,8.01163317 10.8389398,7.59718427 L10.8333333,7.5 L10.8325,3.33333333 L9.64530861,3.33333333 L6.96981575,7.91989252 C6.83706736,8.14746119 6.60575687,8.29713262 6.34782979,8.32758345 L6.25,8.33333333 L3.75,8.33333333 L3.74916667,15.8333333 L6.24916667,15.8333333 L6.25,11.25 L7.91666667,11.25 L7.91666667,16.6666667 C7.91666667,17.0940299 7.59496651,17.446256 7.1805176,17.4943936 L7.08333333,17.5 L2.91666667,17.5 C2.48930347,17.5 2.13707737,17.1782998 2.08893978,16.7638509 L2.08333333,16.6666667 L2.08333333,8.33333333 C2.08333333,7.4546985 2.76323149,6.7348624 3.62561471,6.67123811 L3.75,6.66666667 L5.77083333,6.66666667 L8.20567711,2.49354829 C8.48138531,2.02090567 8.96967269,1.71627218 9.50939872,1.6722022 L9.64530861,1.66666667 L11.25,1.66666667 Z"></path>' +
  '                    <rect opacity="0" x="0" y="0" width="20" height="20"></rect>' +
  '                </g>' +
  '            </g>' +
  '        </g>' +
  '    </g>' +
  '</svg>'

interface IButtonProps {
  icon?: string
  onClick?(event: MouseEvent<HTMLButtonElement>): void
  style?: CSSProperties
  className?: string
  count?: number
  text?: string
  linkWrapper?: Wrapper
  size?: 'default' | 'small'
}

const InteractButton: React.FC<IButtonProps> = ({
  icon,
  style,
  className,
  count,
  text,
  size = 'default',
  linkWrapper = noopWrapper,
  onClick,
}) => {
  const [iconSize, paddingLeft, fontSize, height, leading] = useMemo(() => {
    switch (size) {
    case 'small':
      return [16, 2, 'tw-text-12', 'tw-h-18', 'tw-leading-18']
    default:
      return [20, 4, 'tw-text-16', 'tw-h-22', 'tw-leading-22']
    }
  }, [size])

  const showCount = useMemo(() => {
    return typeof count === 'number' && count > 0 ? formatNumber(count) : ''
  }, [count])

  return (
    <React.Fragment>
      <button
        type={'button'}
        className={classNames(className, 'tw-mr-24', fontSize, height, leading)}
        style={style}
        onClick={onClick}
      >
        {linkWrapper(
          <span
            className={classNames('tw-inline-block', height, {
              icon,
            })}
            style={{
              paddingLeft: icon
                ? iconSize + (showCount || text ? paddingLeft : 0)
                : 0,
            }}
          >
            {`${showCount}${text || ''}`}
          </span>
        )}
      </button>
      <style jsx>
        {`
          button:last-child {
            margin-right: 0;
          }
          .icon {
            background: url('${icon}') left center/ ${iconSize}px ${iconSize}px
              no-repeat;
          }
        `}
      </style>
    </React.Fragment>
  )
}

interface IDiggButtonProps
  extends IToggleDiggParams,
    Omit<IButtonProps, 'onClick'> {
  onClick?(status: boolean): void
}

// 点赞按钮
export const DiggButton: React.FC<IDiggButtonProps> = ({
  id,
  type,
  hasDigg,
  diggCount,
  groupId,
  cellStyle,
  articleType,
  onClick,
  ...props
}) => {
  const {
    update: toggle,
    curStatus,
    curCount,
  } = useToggleDigg({
    id,
    type,
    hasDigg,
    diggCount,
    groupId,
    cellStyle,
    articleType,
  })

  const handleClick = stopPropagation(
    preventDefault(
      useCallback(() => {
        if (onClick) {
          onClick(curStatus)
        }
        if (toggle) {
          toggle()
        }
      }, [onClick, curStatus, toggle])
    )
  )

  return (
    <InteractButton
      icon={curStatus ? diggActiveIcon : diggNormalIcon}
      onClick={handleClick}
      text={'点赞'}
      count={curCount}
      {...props}
    />
  )
}

interface ICollectButtonProps extends Omit<IButtonProps, 'onClick'> {
  id?: string // 主id
  collected?: boolean // 当前是否点赞/收藏
  collectCount?: number // 点赞/收藏数
  showCount?: boolean
  theme?: 'light' | 'black'
  renderText?(status: boolean): string
  onClick?(status: boolean): void
}

// 收藏按钮
export const CollectButton: React.FC<ICollectButtonProps> = ({
  theme = 'light',
  id,
  collected,
  collectCount,
  showCount = false,
  renderText,
  onClick,
  ...props
}) => {
  const {
    update: toggle,
    curStatus,
    curCount,
  } = useToggleCollect({
    id: id || '',
    collected,
    collectCount,
  })

  const handleClick = stopPropagation(
    preventDefault(
      useCallback(() => {
        if (onClick) {
          onClick(curStatus)
        }
        if (toggle) {
          toggle()
        }
      }, [onClick, curStatus, toggle])
    )
  )

  return (
    <InteractButton
      icon={
        curStatus
          ? theme === 'light'
            ? collectActiveIcon
            : collectActiveIconBlack
          : theme === 'light'
            ? collectNormalIcon
            : collectNormalIconBlack
      }
      onClick={handleClick}
      text={renderText?.(curStatus) || '收藏'}
      count={showCount ? curCount : undefined}
      {...props}
    />
  )
}

export function stopPropagation(callback?: MouseEventHandler<HTMLElement>) {
  return useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation()
      if (callback) {
        callback(event)
      }
    },
    [callback]
  )
}

export function preventDefault(callback?: MouseEventHandler<HTMLElement>) {
  return useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault()
      if (callback) {
        callback(event)
      }
    },
    [callback]
  )
}

export interface IProps {
  id?: string // 主id 组件用于评论就传评论id 用于文章就传文章id
  diggType?: IToggleDiggParams['type']
  isOwnerDigg?: boolean // 圈主点赞
  questionStatus?: number // 答案状态
  questionDisplay?: string // 答案状态显示文字
  time?: number // 时间
  timeUnit?: string // 时间描述文字
  awardText?: string // 悬赏文字
  awardIcon?: string // 悬赏图标
  commentVisible?: boolean // 显示评论按钮
  commentCount?: number // 评论数
  diggVisible?: boolean // 显示点赞按钮
  diggCount?: number // 点赞数
  selfHasDigg?: boolean // 当前用户是否点赞
  groupId?: string // 文章id 用于对评论点赞
  cellStyle?: number // 点赞类型
  articleType?: number // 文章类型
  commentLinkWrapper?: Wrapper // 评论跳转链接
  commentText?: string // 评论按钮文字
  collectVisible?: boolean // 显示收藏按钮
  collected?: boolean // 是否收藏
  communityId?: string // 车友圈id
  communityName?: string // 车友圈名称
  onClickComment?(event: MouseEvent<HTMLButtonElement>): void
  onClickCollect?(status: boolean): void
  onClickCommunity?(): void
  onClickDigg?(status: boolean): void
}

const Interact: React.FC<IProps> = ({
  id,
  diggType,
  isOwnerDigg,
  questionStatus,
  questionDisplay,
  awardText,
  awardIcon,
  time,
  timeUnit,
  commentVisible = true,
  commentCount,
  diggVisible = true,
  diggCount,
  selfHasDigg,
  groupId,
  cellStyle,
  articleType,
  commentText = '评论',
  collectVisible = true,
  collected,
  communityId,
  communityName,
  commentLinkWrapper = noopWrapper,
  onClickComment,
  onClickCollect,
  onClickCommunity,
  onClickDigg,
}) => {
  const communityLinkWrapper = useMemo(
    () => communityLink({ id: communityId }),
    [communityId]
  )

  const handleClickCommunity = stopPropagation(onClickCommunity)

  const handleClickComment = stopPropagation(onClickComment)

  return (
    <React.Fragment>
      <div className="tw-mt-20 tw-h-22 tw-flex tw-leading-22">
        <div className="tw-flex tw-items-center tw-flex-1 tw-overflow-hidden tw-mr-24 tw-text-14">
          {communityName ? (
            <span
              className="community line-1 tw-mr-20 tw-pl-20 hover:tw-text-common-orange"
              onClick={handleClickCommunity}
            >
              {communityLinkWrapper(communityName)}
            </span>
          ) : null}
          {isOwnerDigg ? (
            <span className="tw-mr-8 tw-text-12 tw-w-56 tw-h-20 tw-text-center tw-leading-20 tw-bg-video-light-gray tw-flex-none">
              圈主点赞
            </span>
          ) : null}
          {time ? (
            <span className="tw-text-video-shallow-gray tw-flex-none">
              {formatTime(time * 1000)}
              {timeUnit}
            </span>
          ) : null}
        </div>
        <div className="tw-flex tw-items-center tw-flex-none">
          {questionStatus === 0 && awardText ? (
            <span
              className={classNames(
                'tw-inline-block tw-h-22 tw-mr-24',
                awardIcon ? 'coin tw-pl-24' : ''
              )}
            >
              {awardText}
            </span>
          ) : null}
          {commentVisible ? (
            <InteractButton
              icon={replyIcon}
              onClick={handleClickComment}
              text={commentText}
              count={commentCount}
              linkWrapper={commentLinkWrapper}
              className="hover:tw-text-common-orange"
            />
          ) : null}
          {diggVisible ? (
            <DiggButton
              id={id}
              groupId={groupId}
              diggCount={diggCount}
              hasDigg={selfHasDigg}
              cellStyle={cellStyle}
              articleType={articleType}
              type={diggType}
              className="hover:tw-text-common-orange"
              onClick={onClickDigg}
            />
          ) : null}
          {collectVisible ? (
            <CollectButton
              id={id}
              collected={collected}
              className="hover:tw-text-common-orange"
              onClick={onClickCollect}
            />
          ) : null}
          {questionStatus ? (
            <InteractButton
              className="tw-text-common-green tw-cursor-auto"
              text={questionDisplay}
            />
          ) : null}
        </div>
      </div>
      <style jsx>
        {`
          .community {
            background: url(${require('static/cheyouquan_icon.png')}) left
              center / 16px 16px no-repeat;
          }
          .coin {
            background: url(${awardIcon}) left center / 18px 18px no-repeat;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default Interact
